import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, CardTitle, Drawer } from '@reveni-io/reveni-ui'

import DelayDaysInput from '@/common/components/DelayDaysInput/DelayDaysInput'
import ReasonField from '@/common/components/ReasonField/ReasonField'
import RefundHoldModeSelector from '@/common/components/RefundHoldModeSelector/RefundHoldModeSelector'
import { refundHoldModeValues } from '@/common/constants'

import { isPutRefundOnHoldValid } from './helpers'
import * as Styles from './styles'

const PutRefundOnHoldDrawer = ({
  show,
  onClose,
  onPutRefundOnHold,
  puttingRefundOnHold,
  mode,
  setMode,
  delayDays,
  setDelayDays,
  reason,
  setReason,
}) => {
  const { t } = useTranslation()

  const isDelayMode = mode === refundHoldModeValues.delayByDays
  const isValid = isPutRefundOnHoldValid({ mode, delayDays, reason })

  const handleChangeMode = e => setMode(e.target.value)

  const handleChangeDelayDays = e => setDelayDays(e.target.value)

  const handleChangeReason = e => setReason(e.target.value)

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Poner reembolso en espera')}</CardTitle>
      <Styles.MainContainer>
        <RefundHoldModeSelector value={mode} onChange={handleChangeMode} />
        {isDelayMode && <DelayDaysInput value={delayDays} onChange={handleChangeDelayDays} />}
        <ReasonField value={reason} onChange={handleChangeReason} />
        <Styles.ButtonsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Confirmar')}
            loadingLabel={t('Confirmando')}
            onClick={onPutRefundOnHold}
            loading={puttingRefundOnHold}
            disabled={puttingRefundOnHold || !isValid}
          />
        </Styles.ButtonsContainer>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default PutRefundOnHoldDrawer
